import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Flex, FlexColumn, Text } from 'core/components';
import AlertSeverityBars from 'app/views/alerting/components/AlertSeverityBars';
import { formatDateTime } from 'core/util/dateUtils';

@inject('$alerting', '$auth')
@observer
class AlertSeverityHistory extends Component {
  render() {
    const { $alerting, severityHistory = [] } = this.props;

    if (!Array.isArray(severityHistory) || severityHistory.length < 2) {
      return null;
    }

    return (
      <FlexColumn gap="4px">
        {severityHistory.map((_, idx) => {
          const { severity, start_time } = severityHistory[severityHistory.length - 1 - idx];
          const prevEntry = severityHistory[severityHistory.length - 1 - idx - 1];
          const escalationLabel = $alerting.getSeverityChange(prevEntry?.severity, severity);

          return (
            <Flex key={start_time} justifyContent="space-between" gap={1} pt="4px" borderTop="thin" alignItems="center">
              <Flex gap={1} alignItems="center">
                <AlertSeverityBars severity={severity} showLabel={false} />
                <Text muted={idx !== 0} fontWeight={idx === 0 ? 'bold' : 'none'}>
                  {escalationLabel} {$alerting.getSeverityLabel(severity)}
                </Text>
              </Flex>
              <Text as="div" small>
                {formatDateTime(start_time)}
              </Text>
            </Flex>
          );
        })}
      </FlexColumn>
    );
  }
}

export default AlertSeverityHistory;
